























































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import GlobalMixins from '../mixins';

const onClickaway = require('vue-clickaway');

@Component({
	directives: {
		onClickaway: onClickaway.directive
	}
})
export default class StatementTitle extends GlobalMixins {
	@Prop({ required: true }) title!: string | {[key: number]: string | {text: string, information: string}}

	tooltipOpen: number = -1
	tooltipJustChanged: boolean = false

	@Watch('tooltipOpen')
	onTooltipOpenChange() {
		if (this.tooltipOpen === -1) {
			this.$emit('closed')

			this.tooltipJustChanged = true

			setTimeout(() => {
				this.tooltipJustChanged = false
			}, 100)
		} else {
			this.$emit('opened')
		}
	}

	toggleTooltip(index: number, stagger?: true) {
		if (stagger) {
			Vue.nextTick(() => {
				if (this.tooltipJustChanged) return

				if (this.tooltipOpen === index) {
					this.tooltipOpen = -1
				} else {
					this.tooltipOpen = index
				}
			})
		} else {
			if (this.tooltipJustChanged) return

			if (this.tooltipOpen === index) {
				this.tooltipOpen = -1
			} else {
				this.tooltipOpen = index
			}
		}
	}

	created() {
		document.addEventListener('keyup', e => {
			if (e.code === 'Escape') {
				this.tooltipOpen = -1
			}
		})
	}
}
